export default __webpack_public_path__ + "static/di.harald.schneider-6214c94143b21c0d7abe0aba60821b6f.jpg";